export interface ModalOptions {
  title?: string;
  message?: string;
  showButtons?: boolean;
  sticky?: boolean;
  template?: any;
  size?: string;
  component?: any;
  data?: any;
  okLabel?: string;
  cancelLabel?: string;
  hideCancel?: boolean;
  hideSubmit?: boolean;
  hideClose?: boolean;
  windowClass?: string;
  defaultFocus?: 'submit' | 'cancel' | 'content' | 'close';
}
